import { createSlice } from '@reduxjs/toolkit';

let initialOrganizationState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    organizationForEdit: {},
    lastError: null,
};

export const callTypes = {
    list: 'list',
    action: 'action',
};

export const organizationSlice = createSlice({
    name: 'organization',
    initialState: initialOrganizationState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        // getBranchById
        organizationFetched: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.organizationForEdit = action.payload.organizationForEdit;
        },
        // findBranchs
        organizationsFetched: (state, action) => {
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
        },

        childsFetched: (state, action) => {
            state.dataChilds = action.payload.childsFetched
            state.listLoading = false;
            state.error = null;
            state.actionsLoading = false;
        },

        parentsFetched: (state, action) => {
            state.dataParents = action.payload.parentsFetched
            state.listLoading = false;
            state.error = null;
            state.actionsLoading = false;
        },

        donationHistorysFetched: (state, action) => {
            const { total_items, items } = action.payload;
            state.dataDonation = items
            state.listLoading = false;
            state.error = null;
            state.actionsLoading = false;
            state.totalDonationCount = total_items
        },

        // Set to default state actionLoading & error
        organizationsReload: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.error = null;
        },

    },
});

